// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, Validators, FormGroup } from '@angular/forms';
// import { CustomValidators } from 'ng2-validation';
// import { Router } from '@angular/router';
// import { CookieService } from 'ngx-cookie-service';
// import { AuthService } from '../shared/services/auth.service';

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
// })
// export class LoginComponent implements OnInit {
//   loginForm: FormGroup;
//   passwordVisible = false;
//   isSpinning: boolean;
//   isLoggingIn: boolean;

//   constructor(
//     private fb: FormBuilder,
//     private router: Router,
//     private cookieService: CookieService,
//     private srvLogin: AuthService
//   ) {}

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       Email: [null, [Validators.required, CustomValidators.email]],
//       Password: [null, [Validators.required]],
//     });
//   }

//   submitForm() {
//     this.isLoggingIn = true;
//     let obj = {
//       Email: this.loginForm.controls.Email.value,
//       Password: this.loginForm.controls.Password.value,
//     };

//     this.cookieService.set('loginStatus', '1', null, '/');
//     this.cookieService.set('adminId', '101', null, '/');
//     this.cookieService.set('adminName', 'Donna Jones', null, '/');
//     this.cookieService.set('adminEmail', obj.Email, null, '/');
//     this.cookieService.set('adminPassword', obj.Password, null, '/');

//     if (this.srvLogin.checkLogValues(obj)) {
//       this.srvLogin.isloggedin = true;
//       this.router.navigate(['/resources']);
//     } else {
//       // alert('Invalid email')
//       //  this.toast.success({
//       //     title: "Error",
//       //     msg: 'Invalid credentials',
//       //     timeout: 3000,
//       //     theme: "bootstrap",
//       // });
//     }
//   }
// }

import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../shared/services/auth.service';
import { AuthenticationService } from '../shared/services/authentication.service';
import { WebService } from '../shared/services/web.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  passwordVisible = false;
  isSpinning: boolean;
  isLogin: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private cookieService: CookieService,
    private srvLogin: AuthService,
    private authenticationService: AuthenticationService,
    private toast: ToastyService,
    private webapi: WebService,
    private notification: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      Email: [null, [Validators.required, CustomValidators.email]],
      Password: [null, [Validators.required]],
    });
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  submitForm() {
    this.isLogin = true;
    let obj = {
      Email: this.loginForm.controls.Email.value,
      Password: this.loginForm.controls.Password.value,
    };
    this.webapi.requestJson('adminLogin', obj).subscribe(
      (data) => {
        console.log("data ==>",data)
        let response = JSON.parse(data.body);
        let userData = response.data;

        this.createNotification('success', '', response['Message']);
        this.isLogin = false;

        this.cookieService.set('loginStatus', '1', null, '/');
        this.cookieService.set('adminId', userData.admin_id, null, '/');
        this.cookieService.set(
          'adminName',
          userData.first_name + ' ' + userData.last_name,
          null,
          '/'
        );
        this.cookieService.set('adminEmail', userData.email, null, '/');
        this.authenticationService.setCurrentUser(userData);
        this.srvLogin.isloggedin = true;
        this.router.navigate(['/resources']);
      },
      (error) => {
        this.isLogin = false;
        console.log(error);
        this.createNotification('error', '', 'Invalid credentials');
      }
    );
  }
}
